import {pathOr} from 'ramda';
import Highlighter from 'react-highlight-words';
import {render} from 'storyblok-rich-text-react-renderer';

const prepareSearchedStories = (stories, searchedValue) => {
  return stories.map((story) => {
    const arrayOfText = [];

    render(story.content.content, {
      // @ts-ignore
      textResolver: (text) => {
        arrayOfText.push(text);
      },
    });

    const text =
      arrayOfText.find((item) => item.includes(searchedValue)) ||
      arrayOfText[0] ||
      '';

    return {
      id: story.uuid,
      title: (
        <Highlighter
          highlightClassName="underline"
          searchWords={[searchedValue]}
          autoEscape={true}
          textToHighlight={pathOr('', ['content', 'title'], story)}
        />
      ),
      href: pathOr('', ['full_slug'], story),
      text: (
        <Highlighter
          highlightClassName="underline"
          searchWords={[searchedValue]}
          autoEscape={true}
          textToHighlight={text}
        />
      ),
    };
  });
};

export default prepareSearchedStories;
